// @ts-nocheck
import React, { useState } from 'react';
import { supabase } from '../../../lib/supabaseClient';

interface Props {
  groupId: string;
  onClose: () => void;
}

const InviteDialog: React.FC<Props> = ({ groupId, onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const handleInvite = async () => {
    if (!email) return;
    setLoading(true);
    const { data, error } = await supabase.functions.invoke('send_invite', {
      body: { group_id: groupId, email }
    });
    setLoading(false);
    if (error) {
      setMessage(error.message);
    } else {
      setMessage('Invite sent!');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded p-6 w-96 space-y-4">
        <h2 className="text-xl font-semibold">Invite Member</h2>
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Email"
          className="w-full border rounded p-2"
        />
        {message && <p className="text-sm text-center">{message}</p>}
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1 text-sm">Close</button>
          <button
            onClick={handleInvite}
            disabled={loading}
            className="px-3 py-1 bg-blue-600 text-white rounded text-sm"
          >
            {loading ? 'Sending...' : 'Send Invite'}
          </button>
        </div>
      </div>
    </div>
  );
};
export default InviteDialog; 